import type { ReactNode } from "react";
export function Alert({ tone = "info", children }: { tone?: "info" | "error" | "success"; children: ReactNode }) { return <div className={`alert alert-${tone}`} role={tone === "error" ? "alert" : "status"}>{children}</div>; }
